import merge from 'lodash/merge';

import { xmLocalStorage } from '@xmatters/common/utils/xmStorage';

/* eslint-disable no-param-reassign, no-console */

/**
 * Creates a redux store enhancer to persist state to xmLocalStorage or xmSessionStorage
 * @param {object} config - config object
 * @param {string} config.storage - storage to use
 * @param {string} config.key - key to save under in the storage
 * @param {function} config.slicer - function to retrieve a subset of the state
 */
export default function persistState({
  //
  storage = xmLocalStorage,
  key,
  slicer,
}) {
  return next => (reducer, initialState, enhancer) => {
    if (typeof initialState === 'function' && typeof enhancer === 'undefined') {
      enhancer = initialState;
      initialState = undefined;
    }

    let persistedState;
    let finalInitialState = initialState;

    try {
      const item = storage.getItem(key);
      if (item) {
        persistedState = JSON.parse(item);
        finalInitialState = merge(initialState, persistedState);
      }
    } catch (e) {
      finalInitialState = initialState;
      if (process.env.NODE_ENV !== 'test')
        console.warn('Failed to retrieve initial state from Web Storage:', e);
    }

    const store = next(reducer, finalInitialState, enhancer);

    store.subscribe(() => {
      const state = store.getState();
      const subset = slicer(state);

      try {
        storage.setItem(key, JSON.stringify(subset));
      } catch (e) {
        if (process.env.NODE_ENV !== 'test')
          console.warn('Unable to persist state to Web Storage:', e);
      }
    });

    return store;
  };
}
